<template>
	<div class="">
		<div class="w-full">
			<div class="form-group w-full">
				<label for="indicator_name">NOME</label>
				<input
					type="text"
					id="indicator_name"
					class="form-control"
					:class="{ 'is-invalid': $v.indicator.name.$error }"
					placeholder="Nome do médico"
					v-model="$v.indicator.name.$model"
					autofocus
				/>
				<div class="invalid-feedback">OBRIGATÓRIO</div>
			</div>
		</div>
		<div class="w-full">
			<div class="form-group w-full">
				<label for="indicator_cpf">CPF</label>
				<input
					type="text"
					id="indicator_cpf"
					class="form-control"
					:class="{ 'is-invalid': $v.indicator.cpf.$error }"
					placeholder="000.000.000-00"
					v-mask="['###.###.###-##']"
					v-model="$v.indicator.cpf.$model"
				/>
				<div
					class="invalid-feedback"
					v-if="!$v.indicator.cpf.CPFValidation"
				>
					CPF inválido!
				</div>
			</div>
		</div>
		<div class="data-group">
			<div class="form-group w-full md:w-6/12">
				<label for="indicator_professional_advice"
					>CONSELHO PROFISSIONAL</label
				>
				<div
					:class="{
						'position-relative': isLinked,
					}"
				>
					<div
						v-if="isLinked"
						class="w-full h-full position-absolute"
						style="z-index: 10"
					></div>
					<v-select
						:class="{
							readonly: isLinked,
						}"
						v-model="indicator.professional_advice"
						:options="constants.PROFESSIONAL_ADVICE"
						:reduce="o => o.code"
						:get-option-label="o => `${o.code} - ${o.label}`"
						placeholder="BUSCAR CONSELHO"
						:clearable="!isLinked"
						:noDrop="isLinked"
						:tabindex="-1"
					>
						<template #no-options>
							NENHUMA OPÇÃO ENCONTRADA.
						</template>
					</v-select>
				</div>
			</div>
			<div class="form-group w-full md:w-4/12">
				<label for="indicator_number">NÚMERO</label>
				<input
					type="text"
					id="indicator_number"
					class="form-control"
					v-model="indicator.number"
					placeholder="NÚMERO"
					:readonly="isLinked"
				/>
			</div>
			<div class="form-group w-full md:w-2/12">
				<label for="indicator_uf_professional_advice">UF</label>
				<div
					:class="{
						'position-relative': isLinked,
					}"
				>
					<div
						v-if="isLinked"
						class="w-full h-full position-absolute"
						style="z-index: 10"
					></div>
					<v-select
						:class="{
							readonly: isLinked,
						}"
						v-model="indicator.uf_professional_advice"
						:options="states"
						:reduce="o => o.initials"
						:get-option-label="o => `${o.initials}`"
						placeholder="UF"
						:clearable="!isLinked"
						:noDrop="isLinked"
						:tabindex="-1"
					>
						<template #no-options>
							NENHUMA OPÇÃO ENCONTRADA.
						</template>
					</v-select>
				</div>
			</div>
		</div>
		<div class="w-full">
			<div class="form-group w-full">
				<label for="indicator_cbo">CBO</label>
				<div
					:class="{
						'position-relative': isLinked,
					}"
				>
					<div
						v-if="isLinked"
						class="w-full h-full position-absolute"
						style="z-index: 10"
					></div>
					<v-select
						:class="{
							readonly: isLinked,
						}"
						v-model="indicator.cbo"
						:options="constants.CBO"
						:reduce="o => o.code"
						:get-option-label="o => `${o.code} - ${o.label}`"
						placeholder="CÓDIGO OU NOME DA OCUPAÇÃO"
						:clearable="!isLinked"
						:noDrop="isLinked"
						:tabindex="-1"
					>
						<template #no-options>
							NENHUMA OPÇÃO ENCONTRADA.
						</template>
					</v-select>
				</div>
			</div>
		</div>
		<div class="data-group">
			<div class="form-group w-full md:w-10/12">
				<label for="indicator_rqe">RQE</label>
				<input
					type="text"
					id="indicator_rqe"
					class="form-control"
					v-model="indicator.rqe"
					placeholder="RQE"
					:readonly="isLinked"
				/>
			</div>
			<div class="form-group w-full md:w-2/12">
				<label for="indicator_uf_rqe">UF</label>
				<div
					:class="{
						'position-relative': isLinked,
					}"
				>
					<div
						v-if="isLinked"
						class="w-full h-full position-absolute"
						style="z-index: 10"
					></div>
					<v-select
						:class="{
							readonly: isLinked,
						}"
						v-model="indicator.uf_rqe"
						:options="states"
						:reduce="o => o.initials"
						:get-option-label="o => `${o.initials}`"
						placeholder="UF"
						:clearable="!isLinked"
						:noDrop="isLinked"
						:tabindex="-1"
					>
						<template #no-options>
							NENHUMA OPÇÃO ENCONTRADA.
						</template>
					</v-select>
				</div>
			</div>
		</div>
		<div class="w-full">
			<div class="form-group w-full">
				<label for="indicator_phone">TELEFONE</label>
				<input
					type="text"
					id="indicator_phone"
					class="form-control"
					placeholder="(00) 00000-0000"
					v-mask="['(##) #####-####', '(##) ####-####']"
					v-model="indicator.phone"
				/>
			</div>
		</div>
		<div class="data-group">
			<div class="form-group w-full md:w-9/12">
				<label for="indicator_address">ENDEREÇO</label>
				<input
					type="text"
					id="indicator_address"
					class="form-control"
					placeholder="R. São Paulo, 2001"
					v-model="indicator.address"
				/>
			</div>
			<div class="form-group w-full md:w-3/12">
				<label for="indicator_zipcode">CEP</label>
				<input
					type="text"
					id="indicator_zipcode"
					class="form-control"
					placeholder="0000-000"
					v-model="indicator.zipcode"
				/>
			</div>
		</div>
		<div class="data-group">
			<div class="form-group w-full md:w-8/12">
				<label for="indicator_district">BAIRRO</label>
				<input
					type="text"
					id="indicator_district"
					class="form-control"
					placeholder="Centro"
					v-model="indicator.district"
				/>
			</div>
			<div class="form-group w-full md:w-4/12">
				<label for="indicator_complement">COMPLEMENTO</label>
				<input
					type="text"
					id="indicator_complement"
					class="form-control"
					placeholder=""
					v-model="indicator.complement"
				/>
			</div>
		</div>
		<div class="w-full">
			<div class="form-group w-full">
				<label for="indicator_observation">OBSERVAÇÃO</label>
				<textarea
					id="indicator_observation"
					class="form-control"
					placeholder=""
					v-model="indicator.observation"
					cols="30"
					rows="2"
				></textarea>
			</div>
		</div>
		<div class="d-flex flex-wrap justify-content-between">
			<button
				type="button"
				class="btn btn-danger btn-fixed-size"
				:disabled="isLinked"
				@click="DeleteButton"
			>
				EXCLUIR
				<i aria-hidden="true"></i>
			</button>
			<button
				type="button"
				class="btn btn-success btn-fixed-size"
				@click="Save"
			>
				SALVAR
				<i aria-hidden="true"></i>
			</button>
		</div>
	</div>
</template>

<script>
	import Swal from 'sweetalert2'
	import { required, requiredIf } from 'vuelidate/lib/validators'
	import { mapGetters, mapActions } from 'vuex'
	import { PROFESSIONAL_ADVICE, CBO } from '@/constants'

	const CPFValidation = value => {
		if (!value || value.length == 0) return true

		return window.helpers.ValidaCPF(value)
	}

	export default {
		name: 'IndicatorForm',
		props: {
			indicator_base: {
				type: [Object],
				required: false,
				default: () => {},
			},
			base_name: {
				type: String,
				default: '',
			},
			organization_id: {
				type: [String, Number],
				required: false,
				default: null,
			},
		},
		data() {
			return {
				indicator: {
					name: '',
					cpf: '',
					professional_advice: '',
					number: '',
					uf_professional_advice: '',
					cbo: '',
					rqe: '',
					uf_rqe: '',
					address: '',
					district: '',
					complement: '',
					zipcode: '',
					phone: '',
					observation: '',
				},
				constants: {
					PROFESSIONAL_ADVICE,
					CBO,
				},
				states: window.statesBR,
			}
		},
		validations() {
			return {
				indicator: {
					name: {
						required,
					},
					cpf: {
						CPFValidation,
					},
				},
			}
		},
		computed: {
			...mapGetters('auth', ['requester_selected_id']),
			isLinked() {
				return !!this.indicator_base?.stamp_id
			},
		},
		watch: {
			base_name: {
				handler(val) {
					this.indicator.name = val ?? ''
				},
				immediate: true,
			},
			indicator_base: {
				handler(val) {
					if (val) {
						this.indicator = val
					}
				},
				immediate: true,
			},
		},
		methods: {
			...mapActions('system', ['StartLoading', 'FinishLoading']),
			ClearForm(keep_base_name = false) {
				this.indicator = {
					name: keep_base_name ? this.base_name : '',
					cpf: '',
					professional_advice: '',
					number: '',
					uf_professional_advice: '',
					cbo: '',
					rqe: '',
					uf_rqe: '',
					address: '',
					district: '',
					complement: '',
					zipcode: '',
					phone: '',
					observation: '',
				}
			},
			Save() {
				this.$v.indicator.$touch()

				if (this.$v.indicator.$invalid) return

				this.StartLoading()

				window.api
					.call('post', '/new-indicator', {
						...this.indicator,
						organization_id:
							this.organization_id ?? this.requester_selected_id,
					})
					.then(({ data }) => {
						if (data.response) {
							this.$emit('saved', data.indicator)

							Swal.fire({
								icon: 'success',
								toast: true,
								position: 'top',
								timer: 5000,
								html: 'Solicitante salvo',
							})
						} else {
							Swal.fire({
								title: 'Eita!',
								text: 'Houve um erro ao salvar, contate o suporte.',
								icon: 'error',
							})
						}
					})
					.finally(() => {
						this.FinishLoading()
					})
			},
			DeleteButton() {
				Swal.fire({
					title: 'Tem certeza?',
					text: 'Esta ação não pode ser desfeita!',
					icon: 'warning',
					showCancelButton: true,
					confirmButtonText: 'Sim, deletar',
					cancelButtonText: 'Cancelar',
				}).then(result => {
					if (result.isConfirmed) {
						this.Delete(this.indicator)
					}
				})
			},
			async Delete(indicator) {
				this.StartLoading()

				await window.api
					.call('post', '/delete-indicator', {
						...indicator,
					})
					.then(({ data }) => {
						if (data.response) {
							this.$emit('deleted', this.indicator.id)

							Swal.fire({
								title: 'Excluído!',
								text: 'O solicitante foi excluído com sucesso.',
								icon: 'success',
							})
						} else {
							Swal.fire({
								title: 'Erro!',
								text: 'Houve um problema ao tentar deletar o solicitante.',
								icon: 'error',
							})
						}
					})
					.finally(() => {
						this.FinishLoading()
					})
			},
		},
	}
</script>

<style lang="scss" scoped>
	.data-group {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		gap: 1rem;
	}

	.form-control,
	textarea {
		background-color: var(--gridBackgroundColor);
		border: 1px solid var(--elementsBorderColor);

		&:focus {
			background-color: var(--backgroundColorActiveSelected) !important;
			border: solid 1px var(--borderColorActiveSelected);
			color: var(--fontColor);
		}

		&:not(:placeholder-shown) {
			background-color: var(--backgroundColorActiveSelected);
			border: solid 1px var(--borderColorActiveSelected);
			color: var(--fontColorActiveSelected);
		}

		&::placeholder {
			color: var(--fontColorActiveNotSelected);
			opacity: 1;
		}

		&:disabled {
			background-color: var(--backgroundColor) !important;
			color: var(--newColor);
			border: 0.063rem solid var(--newColor);
			cursor: not-allowed !important;
		}

		&[readonly] {
			outline: none;
			border-color: var(--elementsBorderColor);
			color: var(--fontColorActiveNotSelected);
		}
	}

	.grid-layout .btn.btn-fixed-size {
		height: 2.625rem !important;
	}

	::v-deep .v-select {
		--vs-controls-color: var(--fontColorActiveNotSelected);
		--vs-border-color: var(--borderColorActiveNotSelected);
		--vs-border-width: 1px;
		--vs-border-radius: 8px;

		--vs-line-height: 1.4;
		--vs-font-size: 0.875rem;

		--vs-bg: var(--backgroundColorActiveNotSelected);
		--vs-selected-color: var(--fontColorActiveNotSelected);

		--vs-search-input-color: var(--fontColorActiveNotSelected);
		--vs-search-input-bg: var(--backgroundColorActiveNotSelected);
		--vs-search-input-placeholder-color: var(--fontColorActiveNotSelected);

		--vs-dropdown-bg: var(--optionBackgroundColor);
		--vs-dropdown-color: var(--fontColorOption);
		--vs-dropdown-box-shadow: 0 4px 16px rgba(0, 0, 0, 0.5);

		--vs-dropdown-option-padding: 4px 16px;
		--vs-dropdown-option-color: var(--fontColorOption);
		--vs-dropdown-option--active-bg: var(--optionBackgroundColor);
		--vs-dropdown-option--active-color: var(--fontColor);

		--vs-state-disabled-bg: var(--backgroundColorInactive);
		--vs-state-disabled-color: var(--fontColorInactive);
		--vs-state-disabled-controls-color: var(--fontColorInactive);
		--vs-state-disabled-cursor: not-allowed;

		.vs__dropdown-toggle {
			background-color: var(--gridBackgroundColor);
			border-color: var(--elementsBorderColor);
			height: 3.438rem;
			padding: 0.6rem 1.2rem;
			align-items: center;
		}

		.vs__selected-options {
			align-items: center;
			flex-wrap: nowrap;
		}

		.vs__selected {
			margin: 0;
			padding: 0;
			color: var(--fontColorActiveSelected);
		}

		&.vs--open .vs__selected {
			color: var(--fontColorActiveNotSelected);
		}

		.vs__search,
		.vs__search:focus {
			color: var(--fontColorActiveNotSelected);
			background-color: transparent;
			font-size: 0.875rem;
			margin: 0;
			padding: 0;
			line-height: 1.5;
		}

		.vs__dropdown-menu {
			background-color: var(--optionBackgroundColor);
			border-color: var(--borderColorActiveNotSelected);
		}

		.vs__dropdown-option {
			color: var(--fontColorOption);
			font-size: var(--vs-font-size);

			&.vs__dropdown-option--highlight {
				background-color: var(--optionBackgroundColor) !important;
				color: var(--fontColorOptionHover);
			}
		}

		.vs__actions .vs__clear svg {
			width: 14px;
			height: 14px;
		}
	}

	::v-deep .v-select:has(.vs__selected) .vs__dropdown-toggle {
		background-color: var(--backgroundColorActiveSelected) !important;
		border-color: var(--borderColorActiveSelected) !important;
		font-size: var(--vs-font-size) !important;
	}

	::v-deep .v-select:has(.vs__selected) .vs__selected {
		color: var(--fontColorActiveSelected) !important;
	}

	::v-deep .v-select:has(.vs__selected) .vs__search,
	::v-deep .v-select:has(.vs__selected) .vs__search:focus {
		color: var(--fontColorActiveSelected) !important;
	}

	:deep(.v-select.readonly) {
		.vs__dropdown-toggle {
			outline: none;
			background-color: var(--dark-light) !important;
			border-color: var(--elementsBorderColor) !important;

			.vs__selected {
				color: var(--fontColorActiveNotSelected) !important;
			}
		}
	}
</style>
